import $ from 'jquery';
import 'slick-carousel';

$('[data-slick]').slick({
  rtl: $('html').attr('dir') === 'rtl',
});
